class ScrollLock {
    constructor() {
        this.scrollPosition = 0;
        this.isLocked = false;
    }

    disableScroll() {
        if (this.isLocked) return;

        this.scrollbarWidth = this.getScrollbarWidth();
        const body = document.body;

        if (this.scrollbarWidth > 0) {
            body.style.paddingRight = `${this.scrollbarWidth}px`;
        }

        this.scrollPosition = window.scrollY || document.documentElement.scrollTop;
        body.classList.add('scroll-lock-active');

        body.style.position = 'fixed';
        body.style.top = `-${this.scrollPosition}px`;

        this.isLocked = true;
    }

    enableScroll() {
        if (!this.isLocked) return;

        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.paddingRight = '';

        window.scrollTo(0, this.scrollPosition);

        document.body.classList.remove('scroll-lock-active');

        this.isLocked = false;
    }

    /* Create a div and check and save scrollbarWidth and remove again */
    getScrollbarWidth() {
        const scrollDiv = document.createElement('div');
        scrollDiv.style.visibility = 'hidden';
        scrollDiv.style.overflow = 'scroll';
        scrollDiv.style.width = '100px';
        scrollDiv.style.height = '100px';
        document.body.appendChild(scrollDiv);

        const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

        document.body.removeChild(scrollDiv);

        return scrollbarWidth;
    }
}

const scrollLock = new ScrollLock();
export default scrollLock;
